import script from "./Page14.vue?vue&type=script&setup=true&lang=js"
export * from "./Page14.vue?vue&type=script&setup=true&lang=js"

import "./Page14.vue?vue&type=style&index=0&id=0bd9425e&lang=less"

const __exports__ = script;

export default __exports__